import { TableHeader, type TableSortOrder } from '@/components/Table'

export interface DocumentManagementTableHeaderColumn {
  id: string
  header: string
  sortable: boolean
  sortOrder?: TableSortOrder
}

export interface DocumentManagementTableHeaderRowProps {
  columns: DocumentManagementTableHeaderColumn[]
  onSort: (columnId: string, direction: TableSortOrder) => void
}

export function DocumentManagementTableHeaderRow({
  columns,
  onSort,
}: DocumentManagementTableHeaderRowProps) {
  return (
    <>
      {columns.map((col) => (
        <TableHeader
          key={col.id}
          canSort={col.sortable}
          align="left"
          sortOrder={col.sortOrder}
          onSort={(direction) => onSort(col.id, direction)}
        >
          {col.header}
        </TableHeader>
      ))}
    </>
  )
}
